/**
 * Configuration file for Pickup Date Picker
 * Customize disabled dates, holidays, and business rules here
 */

// Update the CONFIG object in pickup-date-picker.js with these values
// Or modify this file and include it before pickup-date-picker.js

window.PickupDatePickerConfig = {
  // Time cutoff (4:30 PM CST)
  cutoffTime: '16:30',
  timezone: 'America/Chicago',
  
  // Disabled weekdays (0 = Sunday, 1 = Monday, etc.)
  disabledWeekdays: [0], // Sundays
  
  // Minimum days ahead (1 = next day, 2 = day after next, etc.)
  minDaysAhead: 1,
  
  // Specific dates to disable (holidays, maintenance days, etc.)
  // Format: 'YYYY-MM-DD'
  disabledDates: [
    // 2024 Holidays (add your specific dates)
    '2024-12-25', // Christmas
    '2024-11-28', // Thanksgiving
    '2024-01-01', // New Year's Day
    '2024-07-04', // Independence Day
    // Add more holidays as needed
    
    // Maintenance days (example)
    // '2024-12-15', // Maintenance day
    
    // 2025 Holidays (add future dates)
    '2025-01-01', // New Year's Day 2025
    '2025-07-04', // Independence Day 2025
    '2025-11-27', // Thanksgiving 2025
    '2025-12-25', // Christmas 2025
    '2025-12-29', // Maintenance Day 2025
    '2026-01-01' //Newe Year's Day 2026
  ]
};

/**
 * Helper function to add holidays for a year
 * Call this to easily add common holidays
 */
function addCommonHolidays(year) {
  const holidays = [
    `${year}-01-01`, // New Year's Day
    `${year}-07-04`, // Independence Day
    `${year}-12-25`, // Christmas
  ];
  
  // Thanksgiving (4th Thursday of November)
  const thanksgiving = getThanksgivingDate(year);
  holidays.push(thanksgiving);
  
  return holidays;
}

/**
 * Calculate Thanksgiving date (4th Thursday of November)
 */
function getThanksgivingDate(year) {
  const november = new Date(year, 10, 1); // November 1st
  const firstThursday = 1 + (4 - november.getDay() + 7) % 7; // First Thursday
  const thanksgiving = new Date(year, 10, firstThursday + 21); // 4th Thursday
  const month = String(thanksgiving.getMonth() + 1).padStart(2, '0');
  const day = String(thanksgiving.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Example: Add holidays for multiple years
if (window.PickupDatePickerConfig) {
  const currentYear = new Date().getFullYear();
  const holidays2024 = addCommonHolidays(2024);
  const holidays2025 = addCommonHolidays(2025);
  const holidays2026 = addCommonHolidays(2026);
  
  window.PickupDatePickerConfig.disabledDates = [
    ...window.PickupDatePickerConfig.disabledDates,
    ...holidays2024,
    ...holidays2025,
    ...holidays2026
  ];
}

